import axios from "axios"
import { del, get, post, put } from "./api_helper"
import * as url from "./apache_url"


// Gets the logged in user data from local session
const getLoggedInUser = () => {
  const user = localStorage.getItem("user")
  if (user) return JSON.parse(user)
  return null
}

//is user is logged in
const isUserAuthenticated = () => {
  return getLoggedInUser() !== null
}

// Register Method
export const postRegister = data => {
  return axios
    .post(url.POST_REGISTER, data)
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data
      throw response.data
    })
    .catch(err => {
      let message
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found"
            break
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team"
            break
          case 401:
            message = "Invalid credentials"
            break
          default:
            message = err[1]
            break
        }
      }
      throw message
    })
}
export const TOAST_OPTIONS2 = {
  preventDuplicates: true,
  positionClass: "toast-top-right",
  closeButton: true,
  progressBar: true,
  progressAnimation: 'increasing',
  newestOnTop: true,
  timeOut: 60000,
  hideProgressBar: false,
  pauseOnHover: true,
  draggable: true
}

export const downloadBase64File = (base64String, fileName, fileExtension, contentType) =>{
  const blob = base64ToBlob(base64String, contentType);
  const url = URL.createObjectURL(blob);
  // const fullFileName = `ehub-${fileName}`;//`.${fileExtension}`;
  const fullFileName = fileName.includes('.') ? `BRIDGE-${fileName}` : `BRIDGE-${fileName}.${fileExtension}`;
  const a = document.createElement('a');
  a.href = url;
  a.download = fullFileName;
  a.click();
  URL.revokeObjectURL(url);
}
export const getContentTypeFromBase64 = (base64String) => {
  const matches = base64String.match(/^data:(.+);base64,/);
  if (matches && matches.length > 1) {
    return matches[1];
  }
  return null;
}

function base64ToBlob(base64String, contentType) {
  const sliceSize = 512;
  const byteCharacters = atob(base64String);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, { type: contentType });
}


export const HRConfig = {
  auth: {
    username: url.HRMIS,
    password: url.HRMISPASS,
  },
  headers: {
    'Content-Type': 'application/json'
  }
}

export const HRConfig2 = {
  auth: {
    username: url.HRMIS,
    password: url.HRMISPASS,
  },
  headers: {
    'Content-Type': 'application/json'
  }
}
export const ReportConfig = {
  auth: {
    username: url.HRMIS,
    password: url.HRMISPASS,
  },
  headers: {
    'Content-Type': 'application/pdf'
    
  },
  responseType: 'blob'
}


export const TOAST_OPTIONS = {
    preventDuplicates: true,
    positionClass: "toast-top-full-width",
    closeButton: true,
    progressBar: true,
    progressAnimation: 'increasing',
    newestOnTop: true,
    autoClose: 30000,
    hideProgressBar: false,
    pauseOnHover: true,
    draggable: true
}
export const TOAST_OPTIONS1 = {
  preventDuplicates: true,
  positionClass: "toast-top-center",
  closeButton: true,
  progressBar: true,
  progressAnimation: 'increasing',
  newestOnTop: true,
  autoClose: 30000,
  hideProgressBar: false,
  pauseOnHover: true,
  draggable: true
}
export const TOAST_OPTIONS3 = {
  preventDuplicates: true,
  positionClass: "toast-top-right",
  closeButton: true,
  progressBar: true,
  progressAnimation: 'increasing',
  newestOnTop: true,
  autoClose: 30000,
  hideProgressBar: true,
  pauseOnHover: true,
  draggable: true
}
export const formatDate = date => {
  var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

  if (month.length < 2) 
      month = '0' + month;
  if (day.length < 2) 
      day = '0' + day;

  return [year, month, day].join('-');
}

export const yearsPast = (initialDate) => { 
  if(initialDate != '0001-01-01'){
    var years = Math.abs(new Date(new Date() - new Date(initialDate)).getUTCFullYear() - 1970);
    return years;
  }else{
    return '-'
  }
}

export const postLogin      = data => post(url.POST_LOGIN, data)
export const postForgetPwd  = data => post(url.POST_PASSWORD_FORGET, data)
export const postProfile    = data => post(url.POST_EDIT_PROFILE, data)

/* export const bkGetLeaveRequests   = () => get(url.LEAVE_REQUESTS, config)
export const bkAddLeaveRequest    = data => post(url.LEAVE_REQUESTS, data, config);
export const bkUpdateLeaveRequest = data => put(url.LEAVE_REQUESTS, data, config);
export const bkDeleteLeaveRequest = data =>  del(url.LEAVE_REQUESTS, { headers: { data } });

export const bkGetLeavePlans    = () => get(url.LEAVE_PLAN, config)
export const bkGetLeavePlanDetails = leavePlanId => get(url.LEAVE_PLAN, leavePlanId, config);
export const bkAddLeavePlan     = data => post(url.LEAVE_PLAN, data, config);
export const bkUpdateLeavePlan  = data => put(url.LEAVE_PLAN, data, config);
export const bkDeleteLeavePlan  = data =>  del(url.LEAVE_PLAN, { headers: { data } });

export const bkGetEmployees   = () => get(url.EMPLOYEES, config)
export const bkAddEmployee    = data => post(url.EMPLOYEES, data, config)
export const bkUpdateEmployee = data => put(url.EMPLOYEES, data, config)
export const bkDeleteEmployee = data => del(url.EMPLOYEES, data, config) */